<div class="modal-body">
    <div class="row">
        <div class="col-md-8 col-sm-8">
            <input type="text" class="form-control" id="searchText"
                   [(ngModel)]="searchText"
                   (keydown)="keydownEvent($event)"
                   (ngModelChange)="filterChanged()"
                   placeholder="type to search..." />
        </div>
        <div class="col-md-4 col-sm-4">
            <div style="margin-top:7px">
                Matches: {{filteredOptions.length}}
            </div>
        </div>
    </div>

    <table class="table">
        <tbody>
            <tr *ngFor="let option of pagedOptions" (click)="optionSelected(option)">
                <td class="rowButton" *ngIf="option != ''">{{option.popUpLabel}}</td>
            </tr>
        </tbody>
    </table>

    <div class="row">
        <div class="col-md-12">
            <pagination class="flex-wrap" [maxSize]="8" [totalItems]="filteredOptions?.length" [(ngModel)]="currentPage"
                        [itemsPerPage]="itemsPerPage" (pageChanged)="pageChanged($event)">
            </pagination>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger pull-left" (click)="clearValue()" *ngIf="column != 'Type'">Clear Selection</button>
    <button type="button" class="btn btn-default" (click)="cancelClicked()">Cancel</button>
</div>
